<template>
  <div class="ai-digital-human-page">
    <section class="hero-section">
      <div class="container">
        <div class="carousel-container">
          <div class="carousel" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
            <div class="carousel-item" v-for="(item, index) in carouselImages" :key="index">
              <img @click="openCustomerService" :src="item" :alt="'轮播图 ' + (index + 1)">
            </div>
          </div>
          <div class="carousel-indicators">
            <span 
              v-for="(item, index) in carouselImages" 
              :key="index"
              class="indicator"
              :class="{ active: currentIndex === index }"
              @click="goToSlide(index)"
            ></span>
          </div>
        </div>
        <div class="hero-layout">
          
          <!-- <div class="hero-copy">
            <h1>AI数字人互动大屏</h1>
            <p class="hero-desc">
              面向展厅接待、品牌活动、政企窗口和线上直播场景，提供可定制的数字人形象、
              实时语音交互与业务知识问答能力，快速打造可落地的数字员工。
            </p>
            <div class="hero-cta">
              <button class="btn-primary" @click="openCustomerService">预约方案演示</button>
              <button class="btn-ghost" @click="openCustomerService">获取行业案例</button>
            </div>
            <div class="hero-metrics">
              <div class="metric-item" v-for="item in metrics" :key="item.label">
                <div class="metric-value">{{ item.value }}</div>
                <div class="metric-label">{{ item.label }}</div>
              </div>
            </div>
          </div>
          <div class="hero-media">
            <img
              src="https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1200&q=80"
              alt="AI数字人互动大屏演示"
            >
          </div> -->
        </div>
      </div>
    </section>

    <section class="features-section">
      <div class="container">
        <h2>核心能力</h2>
        <div class="feature-grid">
          <div class="feature-card" v-for="item in features" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

        <section class="showcase-section">
      <div class="container">
        <h2>应用场景</h2>
        <div class="showcase-grid">
          <div class="showcase-card" v-for="item in showcases" :key="item.title">
            <img style="object-fit: contain;" :src="item.image" :alt="item.title">
            <div class="showcase-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
<!-- 
    <section class="success-cases-section">
      <div class="container">
        <h2>成功案例</h2>
        <div class="cases-grid">
          <div class="case-card" v-for="item in successCases" :key="item.client">
            <img class="case-logo" :src="item.logo" :alt="item.client" />
            <div class="case-content">
              <h3>{{ item.client }}</h3>
              <p>{{ item.achievement }}</p>
            </div>
          </div>
        </div>
      </div>
    </section> -->



    <section class="contact-section">
      <div class="container">
        <div class="contact-wrapper">
          <div class="contact-info">
            <h2>获取您的AI数字人解决方案</h2>
            <p class="contact-desc">填写信息，我们将为您提供：</p>
            <ul class="contact-benefits">
              <li>行业场景方案建议</li>
              <li>1对1功能演示与PoC支持</li>
              <li>成功案例详细解读</li>
            </ul>
          </div>
          <div class="contact-form">
            <form @submit.prevent="submitForm">
              <div class="form-group">
                <label>姓名/称呼 <span class="required">*</span></label>
                <input type="text" v-model="formData.name" placeholder="请输入您的姓名" required />
              </div>
              <div class="form-group">
                <label>企业名称 <span class="required">*</span></label>
                <input type="text" v-model="formData.company" placeholder="请输入企业名称" required />
              </div>
              <div class="form-group">
                <label>联系电话 <span class="required">*</span></label>
                <input type="text" v-model="formData.contact" placeholder="请输入联系电话" required />
              </div>
              <div class="form-group">
                <label>感兴趣场景</label>
                <div class="checkbox-group">
                  <label class="checkbox-item">
                    <input type="checkbox" v-model="formData.scenes" value="展厅/门店" />
                    <span>展厅/门店</span>
                  </label>
                  <label class="checkbox-item">
                    <input type="checkbox" v-model="formData.scenes" value="政务/服务大厅" />
                    <span>政务/服务大厅</span>
                  </label>
                  <label class="checkbox-item">
                    <input type="checkbox" v-model="formData.scenes" value="文旅" />
                    <span>文旅</span>
                  </label>
                  <label class="checkbox-item">
                    <input type="checkbox" v-model="formData.scenes" value="其他" />
                    <span>其他</span>
                  </label>
                </div>
              </div>
              <button type="submit" class="submit-btn">申请演示 / 获取方案</button>
            </form>
          </div>
        </div>
      </div>
    </section>






    <section class="dialog-flow-section">
      <div class="container">
        <h2>数字人互动对话流程</h2>
        <div class="flow-grid">
          <div class="flow-item" v-for="(step, index) in dialogFlowSteps" :key="step.title">
            <div class="flow-icon">{{ step.icon }}</div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div v-if="index < dialogFlowSteps.length - 1" class="flow-arrow">›</div>
          </div>
        </div>
      </div>
    </section>

    <section class="interaction-scene-section">
      <div class="container">
        <h2>多种交互场景</h2>
        <div class="scene-tabs">
          <button
            v-for="(tab, index) in interactionTabs"
            :key="tab.name"
            class="scene-tab"
            :class="{ active: activeTabIndex === index }"
            @click="activeTabIndex = index"
          >
            <span class="tab-icon">{{ tab.icon }}</span>
            <span>{{ tab.name }}</span>
          </button>
        </div>
        <div class="scene-panel">
          <img :src="interactionTabs[activeTabIndex].image" :alt="interactionTabs[activeTabIndex].title">
          <div class="panel-copy">
            <h3>{{ interactionTabs[activeTabIndex].title }}</h3>
            <ul>
              <li v-for="point in interactionTabs[activeTabIndex].points" :key="point">{{ point }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="knowledge-layer-section">
      <div class="container">
        <h2>多层级内容回复机制，数字人回复更快、更准、更专业</h2>
        <p class="section-subtext">搭配 QA 问答库、RAG 知识库与大模型能力，构建可持续进化的内容中枢。</p>
        <div class="knowledge-grid">
          <div class="knowledge-card" v-for="item in knowledgeLayers" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p class="layer-name">{{ item.layer }}</p>
            <ul>
              <li v-for="point in item.points" :key="point">{{ point }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="avatar-type-section">
      <div class="container">
        <h2>多种数字人类型，满足行业级定制化需求</h2>
        <div class="avatar-type-grid">
          <div class="avatar-type-card" v-for="item in avatarTypes" :key="item.title">
            <img :src="item.image" :alt="item.title">
            <div class="avatar-type-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="multimodal-section">
      <div class="container">
        <h2>形象、音色与语言定制，打造多模态数字人</h2>
        <p class="section-subtext">从视觉到听觉全面可配置，满足不同品牌与行业的个性化表达需求。</p>
        <div class="multimodal-grid">
          <div class="multimodal-card large" v-for="item in multimodalCards" :key="item.title">
            <img :src="item.image" :alt="item.title">
            <div class="multimodal-copy">
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="scenes-section">
      <div class="container">
        <h2>适用场景</h2>
        <div class="scene-list">
          <div class="scene-item" v-for="scene in scenes" :key="scene">
            {{ scene }}
          </div>
        </div>
      </div>
    </section> -->



        <section class="showcase-section">
      <div class="container">
        <h2>数字人案例</h2>
        <div class="showcase-grid">
          <div class="showcase-card" v-for="item in successCases" :key="item.client">
            <img style="object-fit: contain;" :src="item.logo" :alt="item.client">
            <div class="showcase-content">
           <h3>{{ item.client }}</h3>
              <p>{{ item.achievement }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <section class="why-choose-section">
      <div class="container">
        <h2>为什么选择我们</h2>
        <div class="why-choose-grid">
          <div class="why-choose-card" v-for="item in whyChooseItems" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="contact-section">
      <div class="container">
        <div class="contact-wrapper">
          <div class="contact-info">
            <h2>获取您的AI数字人解决方案</h2>
            <p class="contact-desc">填写信息，我们将为您提供：</p>
            <ul class="contact-benefits">
              <li>行业场景方案建议</li>
              <li>1对1功能演示与PoC支持</li>
              <li>成功案例详细解读</li>
            </ul>
          </div>
          <div class="contact-form">
            <form @submit.prevent="submitForm">
              <div class="form-group">
                <label>姓名/称呼 <span class="required">*</span></label>
                <input type="text" v-model="formData.name" placeholder="请输入您的姓名" required />
              </div>
              <div class="form-group">
                <label>企业名称 <span class="required">*</span></label>
                <input type="text" v-model="formData.company" placeholder="请输入企业名称" required />
              </div>
              <div class="form-group">
                <label>联系电话 <span class="required">*</span></label>
                <input type="text" v-model="formData.contact" placeholder="请输入联系电话" required />
              </div>
              <div class="form-group">
                <label>感兴趣场景</label>
                <div class="checkbox-group">
                  <label class="checkbox-item">
                    <input type="checkbox" v-model="formData.scenes" value="展厅/门店" />
                    <span>展厅/门店</span>
                  </label>
                  <label class="checkbox-item">
                    <input type="checkbox" v-model="formData.scenes" value="政务/服务大厅" />
                    <span>政务/服务大厅</span>
                  </label>
                  <label class="checkbox-item">
                    <input type="checkbox" v-model="formData.scenes" value="文旅" />
                    <span>文旅</span>
                  </label>
                  <label class="checkbox-item">
                    <input type="checkbox" v-model="formData.scenes" value="其他" />
                    <span>其他</span>
                  </label>
                </div>
              </div>
              <button type="submit" class="submit-btn">申请演示 / 获取方案</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-section">
      <div class="cta-card">
        <h2>一周内完成 PoC，快速验证业务价值</h2>
        <p>支持本地化部署与私有知识库接入，提供从形象制作到上线运营的一站式交付。</p>
        <button class="btn-primary" @click="openCustomerService">立即咨询顾问</button>
      </div>
    </section>

    <CustomerService :visible="showCustomerService" @close="closeCustomerService" />
  </div>
</template>

<script>
import CustomerService from '@/components/CustomerService.vue'
import axios from 'axios';

export default {
  name: 'AIDigitalHumanPage',
  components: {
    CustomerService
  },
  data() {
    return {
      activeTabIndex: 0,
      showCustomerService: false,
      formData: {
        name: '',
        company: '',
        contact: '',
        scenes: []
      },
      carouselImages: ['http://www.hnxueding.cn/img/banner.jpg'],
      currentIndex: 0,
      features: [
        {
          title: '多模态实时交互',
          desc: '支持语音、唇形同步与实时问答，沟通自然。'
        },
        {
          title: '企业知识库驱动',
          desc: '接入产品手册、政策文档和业务 FAQ，回答更准确可控。'
        },
        {
          title: '数字人形象定制',
          desc: '提供真人复刻、3D超写实/卡通等风格，匹配品牌调性。'
        },
        {
          title: '运营数据可视化',
          desc: '记录会话、热点问题和用户意图，持续优化转化效果。'
        }
      ],
      whyChooseItems: [
        {
          title: '更快、更准的内容中枢',
          desc: '采用"高频问答库 → 知识库检索 → 大模型兜底"三层机制，回复速度与准确性兼顾。'
        },
        {
          title: '真正的端到端定制',
          desc: '从形象（真人/3D）、声音（多语种/情感音色）到话术风格，完全匹配您的品牌。'
        },
        {
          title: '一周完成PoC，快速验证',
          desc: '支持本地化部署与私有知识库接入，提供从形象制作到上线的一站式交付。'
        },
        {
          title: '数据驱动持续进化',
          desc: '运营看板与意图分析工具，让数字人越用越懂您的业务。'
        }
      ],
      successCases: [
        {
          client: '某博物馆文旅场景',
          logo: 'http://www.hnxueding.cn/img/1.jpg',
          achievement: '部署历史人物定制数字人IP，提升满意度百分之60。'
        },
        {
          client: '某头部品牌展厅',
          logo: 'http://www.hnxueding.cn/img/2.jpg',
          achievement: '使用真人复刻数字人迎宾，日均互动时长4.2分钟，线索收集提升50%。'
        },
        {
          client: '某大型银行省分行',
          logo: 'http://www.hnxueding.cn/img/3.jpg',
          achievement: '在网点大屏上线卡通数字人，业务咨询转化率提升28%。'
        }
      ],
      scenes: ['展厅导览与接待', '线下活动大屏互动', '政企大厅智能咨询', '品牌直播与线上客服'],
      metrics: [
        { value: '98%', label: '语音识别准确率' },
        { value: '24h', label: '全天候在线服务' },
        { value: '7天', label: '最快交付周期' }
      ],
      showcases: [
        {
          title: '政务大厅、医院、银行网点、文旅IP',
          desc: '	7x24小时解答政策/流程，减少窗口压力，提升办事效率。',
          image: 'http://www.hnxueding.cn/img/jiangjie.jpg'
        },
        {
          title: '品牌展厅、发布会、数字大屏',
          desc: '品牌讲解、产品问答、线索收集，提升互动与转化。',
          image: 'http://www.hnxueding.cn/img/jiangjie.jpg'
        },
        {
          title: '员工培训、企业文化展厅、内部服务台',
          desc: '统一知识输出，降低培训成本，提供标准化内部支持。',
          image: 'http://www.hnxueding.cn/img/jiangjie.jpg'
        }
      ],
      dialogFlowSteps: [
        {
          icon: '1',
          title: '语音转文本',
          desc: '将用户语音实时转成可理解文本'
        },
        {
          icon: '2',
          title: '意图识别',
          desc: '对话意图快速解析并命中业务问题'
        },
        {
          icon: '3',
          title: 'AI智能体',
          desc: '统一调度知识库与策略引擎生成回复'
        },
        {
          icon: '4',
          title: '多模态交互',
          desc: '支持闲聊、问答、任务式对话等能力'
        },
        {
          icon: '5',
          title: '文本转语音',
          desc: '回复内容生成自然语音并同步播报'
        }
      ],
      interactionTabs: [
        {
          name: '智慧大屏',
          icon: '',
          title: '智慧大屏AI虚拟人',
          image: 'https://images.unsplash.com/photo-1573496799652-408c2ac9fe98?auto=format&fit=crop&w=1200&q=80',
          points: ['提升品牌科技感与门店形象', '吸引线下流量关注', '辅助门店业务咨询和引导']
        },
        {
          name: '手机APP',
          icon: '',
          title: '手机APP实时交互',
          image: 'https://images.unsplash.com/photo-1556740738-b6a63e27c4df?auto=format&fit=crop&w=1200&q=80',
          points: ['SDK 形式嵌入现有 APP', '实时语音交互，增强沉浸感', '支持 VIP 客户在线服务']
        },
        {
          name: '微信公众号',
          icon: '',
          title: '微信公众号数字人',
          image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=1200&q=80',
          points: ['扫码或公众号菜单一键触达', '适合会员服务与业务办理', '问题反馈与分流更高效']
        },
        {
          name: '微信小程序',
          icon: '',
          title: '微信小程序互动助手',
          image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80',
          points: ['公众号与小程序双端联动', '多渠道流量导入和转化', '支持营销活动实时讲解']
        }
      ],
      knowledgeLayers: [
        {
          title: '问答库系统',
          layer: '首选层',
          points: ['面向高频问题，命中速度快', '支持图文/视频/网页链接回复', '适合标准化业务咨询场景']
        },
        {
          title: '知识库系统',
          layer: '中间层',
          points: ['上传企业文档，构建结构化知识', '支持手册、政策、产品资料检索', '适合复杂业务语义理解']
        },
        {
          title: '大模型微调知识',
          layer: '兜底层',
          points: ['面向开放式问题进行生成回答', '可结合品牌语气和行业术语', '保障对话连续性与专业性']
        }
      ],
      avatarTypes: [
        {
          title: '真人复刻数字人',
          desc: '高度还原真人外观与语音，广泛适用于高端服务场景、品牌活动、政企窗口和线上直播。',
          image: 'http://www.hnxueding.cn/img/zhenren.jpg'
        },
        {
          title: '3D超写实数字人',
          desc: '支持复杂动作与面部表情，适配品牌体验空间。',
          image: 'http://www.hnxueding.cn/img/xieshi3d.jpg'
        },
        {
          title: '3D虚拟卡通数字人',
          desc: '更年轻化的视觉语言，适配新媒体和互动营销。',
          image: 'http://www.hnxueding.cn/img/xunikatong.jpg'
        }
      ],
      multimodalCards: [
        {
          title: '多模态输出',
          desc: '支持文本、图片、视频、网页链接等多样回复方式。',
          image: 'http://www.hnxueding.cn/img/dmt.jpg'
        },
        {
          title: '多语种输出',
          desc: '支持中英日韩等多语种对话，覆盖跨境业务场景。',
          image: 'http://www.hnxueding.cn/img/dyz.jpg'
        },
        {
          title: '多风格声音库',
          desc: '可选情感音色和行业话术风格，声音表达更自然。',
          image: 'http://www.hnxueding.cn/img/dsy.jpg'
        },
        {
          title: '多风格形象库',
          desc: '支持标准形象库与企业专属形象定制，强化品牌识别。',
          image: 'http://www.hnxueding.cn/img/dfg.jpg'
        }
      ]
    }
  },
  methods: {
    openCustomerService() {
      this.showCustomerService = true
    },
    closeCustomerService() {
      this.showCustomerService = false
    },
    submitForm() {
      console.log('submit')
      if(this.formData.contact == '') {
        alert('请输入联系电话')
        return
      }

      axios.post('https://flower.hnxueding.cn/api/user/sendxiansuo', this.formData) 
        .then(response => {
          console.log(response.data)
          alert(response.data.msg)
        })
        .catch(error => console.error(error));
    },
    goToSlide(index) {
      this.currentIndex = index
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.carouselImages.length
    }
  },
  mounted() {
    this.carouselInterval = setInterval(this.nextSlide, 3000)
  },
  beforeUnmount() {
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval)
    }
  }
}
</script>

<style scoped>
.ai-digital-human-page {
  padding-top: 72px;
  min-height: 100vh;
  overflow-x: hidden;
}

.container {
  /* max-width: 1200px; */
  margin: 0 auto;
  padding: 0 20px;
}

.container h2{
  text-align: center;
}

.hero-section {
  background: linear-gradient(135deg, #011348  0%, #011348  100%);
  color: #fff;
  /* padding: 88px 0 72px; */
  overflow: hidden;
}

.carousel-container {
  position: relative;
  width: 100vw;
  left: 50%;
  transform: translateX(-50%);
  height: 700px;
  /* overflow: hidden; */
  border-radius: 12px;
  /* margin-bottom: 30px; */
}

.carousel {
  display: flex;
  transition: transform 0.5s ease;
  /* width: 100%; */
  height: 100%;
}

.carousel-item {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
}

.carousel-item img {
  width: 100%;
  height: 100%;
  object-fit: none;
  display: block;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background: #fff;
  width: 30px;
  border-radius: 5px;
}

.hero-layout {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 36px;
  align-items: center;
}

.hero-tag {
  display: inline-block;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  margin-bottom: 16px;
}

.hero-section h1 {
  font-size: 42px;
  line-height: 1.3;
  margin-bottom: 18px;
}

.hero-desc {
  max-width: 760px;
  line-height: 1.8;
  opacity: 0.95;
}

.hero-cta {
  display: flex;
  gap: 14px;
  margin-top: 26px;
}

.btn-primary,
.btn-ghost {
  border: none;
  border-radius: 10px;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.btn-primary {
  background: #3470ff;
  color: #fff;
}

.btn-ghost {
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.35);
}

.hero-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 28px;
}

.metric-item {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  padding: 14px;
}

.metric-value {
  font-size: 28px;
  font-weight: 700;
}

.metric-label {
  font-size: 13px;
  opacity: 0.9;
}

.hero-media img {
  width: 100%;
  border-radius: 20px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.28);
}

.features-section,
.why-choose-section,
.success-cases-section,
.contact-section,
.scenes-section,
.showcase-section,
.dialog-flow-section,
.interaction-scene-section,
.core-tech-section,
.knowledge-layer-section,
.avatar-type-section,
.multimodal-section,
.cta-section {
  padding: 72px 0;
}

.features-section h2,
.why-choose-section h2,
.scenes-section h2,
.showcase-section h2,
.dialog-flow-section h2 {
  font-size: 32px;
  color: #1f2937;
  margin-bottom: 28px;
}

.interaction-scene-section h2,
.knowledge-layer-section h2,
.avatar-type-section h2,
.multimodal-section h2,
.core-tech-section h2 {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 28px;
  letter-spacing: 0;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.feature-card {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 24px;
  background: #fff;
}

.feature-card h3 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #111827;
}

.feature-card p {
  color: #4b5563;
  line-height: 1.7;
}

.why-choose-section {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
}

.why-choose-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.why-choose-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 28px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.08);
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.why-choose-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
}

.why-choose-card h3 {
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.why-choose-card p {
  color: #4b5563;
  line-height: 1.8;
  font-size: 15px;
}

.success-cases-section {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

.case-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 28px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.08);
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.case-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12);
  border-color: #3470ff;
}

.case-logo {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.1);
}

.case-content h3 {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.case-content p {
  color: #4b5563;
  line-height: 1.7;
  font-size: 15px;
}

.showcase-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.showcase-card {
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);
}

.showcase-card img {
  width: 100%;
  height: 210px;
  object-fit: cover;
}

.showcase-content {
  padding: 18px;
}

.showcase-content h3 {
  color: #111827;
  margin-bottom: 10px;
}

.showcase-content p {
  color: #4b5563;
  line-height: 1.65;
}

.interaction-scene-section {
  background: #f1f4fb;
  padding-top: 88px;
  padding-bottom: 88px;
}

.scene-tabs {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 28px;
}

.scene-tab {
  background: #ffffff;
  border: 1px solid #e5ebf7;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 18px;
  font-weight: 600;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.scene-tab.active {
  border-color: #3470ff;
  box-shadow: 0 10px 20px rgba(52, 112, 255, 0.2);
}

.tab-icon {
  font-size: 22px;
}

.scene-panel {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 22px;
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
}

.scene-panel img {
  width: 100%;
  height: 100%;
  max-height: 360px;
  object-fit: cover;
  border-radius: 12px;
}

.panel-copy {
  padding: 20px 10px;
}

.panel-copy h3 {
  font-size: 34px;
  margin-bottom: 14px;
  color: #0f172a;
}

.panel-copy ul {
  padding-left: 18px;
}

.panel-copy li {
  margin-bottom: 12px;
  color: #334155;
  line-height: 1.7;
}

.full-width-image {
  width: 100%;
  border-radius: 18px;
  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.14);
}

.section-subtext {
  text-align: center;
  color: #64748b;
  margin-bottom: 24px;
}

.knowledge-layer-section {
  background: linear-gradient(180deg, #f5f8ff 0%, #eef3ff 100%);
  padding-top: 88px;
  padding-bottom: 88px;
}

.knowledge-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.knowledge-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 22px;
  border: 1px solid #dbe6ff;
}

.knowledge-card h3 {
  color: #111827;
  margin-bottom: 8px;
}

.layer-name {
  color: #3470ff;
  font-weight: 600;
  margin-bottom: 12px;
}

.knowledge-card ul {
  padding-left: 18px;
}

.knowledge-card li {
  color: #475569;
  margin-bottom: 8px;
}

.avatar-type-section {
  background: linear-gradient(180deg, #04153f 0%, #0b2d75 100%);
  padding-top: 88px;
  padding-bottom: 88px;
}

.avatar-type-section h2 {
  color: #ffffff;
}

.avatar-type-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.avatar-type-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  overflow: hidden;
}

.avatar-type-card img {
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.avatar-type-content {
  padding: 16px;
}

.avatar-type-content h3 {
  color: #ffffff;
  margin-bottom: 8px;
}

.avatar-type-content p {
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.6;
}

.multimodal-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.multimodal-card {
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e7eb;
}

.multimodal-card img {
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.multimodal-copy {
  padding: 18px;
}

.multimodal-copy h3 {
  color: #111827;
  margin-bottom: 10px;
}

.multimodal-copy p {
  color: #4b5563;
  line-height: 1.65;
}

.dialog-flow-section {
  background: #f3f6fb;
}

.flow-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e3e8f2;
}

.flow-item {
  position: relative;
  background: #eef3fb;
  padding: 22px 18px 20px;
  text-align: center;
  min-height: 196px;
  border-right: 1px solid #e3e8f2;
}

.flow-item:last-child {
  border-right: none;
}

.flow-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  background: radial-gradient(circle at 30% 30%, #8fd3ff 0%, #5ea8ff 45%, #2f6dff 100%);
  color: #ffffff;
  box-shadow: 0 8px 18px rgba(47, 109, 255, 0.28);
}

.flow-item h3 {
  font-size: 20px;
  color: #1f2937;
  margin-bottom: 10px;
}

.flow-item p {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.7;
}

.flow-arrow {
  position: absolute;
  right: -13px;
  top: 50%;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #ffffff;
  color: #9db0ce;
  font-size: 24px;
  line-height: 22px;
  z-index: 2;
  box-shadow: 0 4px 10px rgba(148, 163, 184, 0.2);
}

.scenes-section {
  background: #f8fafc;
}

.scene-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.scene-item {
  padding: 18px 20px;
  background: #fff;
  border-left: 4px solid #3470ff;
  border-radius: 10px;
  font-weight: 500;
  color: #1f2937;
}

.cta-section {
  background: #ffffff;
  padding-top: 0;
  padding-bottom: 0;
}

.cta-card {
  width: 100%;
  border-radius: 0;
  background: linear-gradient(135deg, #1d4ed8 0%, #3b82f6 100%);
  color: #ffffff;
  text-align: center;
  padding: 56px 28px;
}

.cta-card h2 {
  font-size: 30px;
  margin-bottom: 12px;
}

.cta-card p {
  opacity: 0.95;
  margin-bottom: 22px;
}

.cta-card .btn-primary {
  background: #ffffff;
  color: #1d4ed8;
}

/* .contact-section {
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%);
  color: #ffffff;
} */

.contact-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}

.contact-info h2 {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.3;
  text-align: left !important;
}

.contact-desc {
  font-size: 18px;
  margin-bottom: 24px;
  opacity: 0.95;
}

.contact-benefits {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-benefits li {
  padding: 12px 0;
  padding-left: 32px;
  position: relative;
  font-size: 16px;
  opacity: 0.9;
}

.contact-benefits li:before {
  content: '✓';
  position: absolute;
  left: 0;
  top: 10px;
  color: #34d399;
  font-weight: 700;
  font-size: 20px;
}

.contact-form {
  background: #ffffff;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.form-group {
  margin-bottom: 24px;
}

.form-group label {
  display: block;
  color: #1f2937;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
}

.required {
  color: #ef4444;
}

.form-group input[type="text"] {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 15px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-group input[type="text"]:focus {
  outline: none;
  border-color: #3470ff;
  box-shadow: 0 0 0 3px rgba(52, 112, 255, 0.1);
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #1f2937;
  font-size: 15px;
}

.checkbox-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #3470ff;
}

.submit-btn {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #3470ff 0%, #1d4ed8 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(52, 112, 255, 0.4);
}

@media (max-width: 768px) {
  .hero-layout {
    grid-template-columns: 1fr;
  }

  .hero-section h1 {
    font-size: 32px;
  }

  .hero-cta {
    flex-direction: column;
  }

  .hero-metrics {
    grid-template-columns: 1fr;
  }

  .feature-grid,
  .why-choose-grid,
  .cases-grid,
  .scene-list,
  .showcase-grid,
  .knowledge-grid,
  .avatar-type-grid,
  .multimodal-grid {
    grid-template-columns: 1fr;
  }

  .scene-tabs {
    flex-wrap: wrap;
  }

  .scene-tab {
    width: calc(50% - 8px);
    justify-content: center;
    font-size: 16px;
  }

  .scene-panel {
    grid-template-columns: 1fr;
  }

  .panel-copy h3 {
    font-size: 28px;
  }

  .interaction-scene-section h2,
  .knowledge-layer-section h2,
  .avatar-type-section h2,
  .multimodal-section h2,
  .core-tech-section h2 {
    font-size: 30px;
    margin-bottom: 22px;
  }

  .flow-grid {
    grid-template-columns: 1fr;
    border: none;
    gap: 12px;
    background: transparent;
  }

  .flow-item {
    border: 1px solid #e3e8f2;
    border-radius: 12px;
    min-height: auto;
  }

  .flow-arrow {
    display: none;
  }

  .cta-card h2 {
    font-size: 24px;
  }

  .contact-wrapper {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .contact-info h2 {
    font-size: 28px;
    text-align: center;
  }

  .contact-desc {
    text-align: center;
  }

  .contact-form {
    padding: 28px;
  }
}
</style>
